var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolarPower = function SvgSolarPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm17 0a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM8 2.5a1 1 0 0 0-2 0C6 5.948 8.831 8 12 8s6-2.052 6-5.5a1 1 0 1 0-2 0C16 4.575 14.354 6 12 6S8 4.575 8 2.5m-.979 5.893A1 1 0 1 0 5.607 6.98l-.814.814a1 1 0 1 0 1.414 1.414zM18.393 6.98a1 1 0 1 0-1.414 1.414l.814.814a1 1 0 1 0 1.414-1.414zM13 10a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0zm-2 5v2H3.51l.202-2zm2 0v2h7.49l-.202-2zm7.692 4H13v2h7.894zM11 21v-2H3.308l-.202 2zm-9.187-7.1c.051-.51.486-.9 1.004-.9h18.366c.518 0 .953.39 1.004.9l.808 8c.06.59-.407 1.1-1.005 1.1H2.01c-.598 0-1.064-.51-1.005-1.1z",
    clipRule: "evenodd"
  })));
};
export default SvgSolarPower;